<template>
  <div>
    <vxe-grid
      ref="table"
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      size="small"
      resizable
      border
      empty-text="没有匹配到符合条件的货物信息"
    >
    </vxe-grid>
    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="confirm()" size="small"
        >确认选择</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    custCode: String,
  },

  data() {
    return {
      loading: false,
      tableData: [],
      tableHeight: 360,
      checkBoxRow: [],
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '选择',
          width: 70,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'goodsNo',
          align: 'center',
          width: 150,
          fixed: 'left',
          title: '货物代码',
        },
        {
          field: 'goodsName',
          align: 'left',
          width: 150,
          title: '货物名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          field: 'goodsTypeName',
          align: 'left',
          width: 100,
          title: '货物类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          field: 'packageTypeName',
          align: 'left',
          width: 100,
          title: '包装类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          field: 'packageLength',
          align: 'left',
          width: 80,
          title: '长',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'packageWidth',
          align: 'left',
          width: 80,
          title: '宽',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'packageHeight',
          align: 'left',
          width: 80,
          title: '高',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'incomeWeight',
          align: 'left',
          width: 140,
          title: '收入重量（公斤）',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'incomeVolume',
          align: 'left',
          width: 140,
          title: '收入体积（立方）',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'expenseWeight',
          align: 'left',
          width: 140,
          title: '支出重量（公斤）',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'expenseVolume',
          align: 'left',
          width: 140,
          title: '支出体积（立方）',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'number',
        },
        {
          field: 'goodsRemarks',
          align: 'left',
          width: 300,
          title: '备注说明',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyTime',
          align: 'left',
          width: 170,
          title: '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
        },
      ],
    }
  },
  created() {
    this.getMasterGoods()
  },

  methods: {
    getMasterGoods() {
      this.loading = true
      this.$api
        .bizOrderGoodsGetCustGoodsApi({custCode: this.custCode})
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    confirm() {
      const selectRecords = this.$refs.table.getCheckboxRecords()
      if (selectRecords.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      this.$confirm('您确定要添加所勾选的数据吗？').then((type) => {
        if (type === 'confirm') {
          this.checkBoxRow = selectRecords
          this.$emit('addTo', this.checkBoxRow)
        }
      })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
